<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in models" :key="item">
      <app-menu-item
        v-if="!item.separator"
        :item="item"
        :index="i"
      ></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<script setup>
import { ref, computed } from "vue"
import store from "@/store"
import AppMenuItem from "./AppMenuItem.vue"

const allModels = ref([
  {
    label: "Home",
    items: [{ label: "Home", icon: "pi pi-fw pi-home", to: "/" }],
    isAdmin: false,
  },
  {
    label: "Pages",
    icon: "pi pi-fw pi-briefcase",
    to: "/pages",
    isAdmin: false,
    items: [
      {
        label: "Создать изображение",
        icon: "pi pi-fw pi-image",
        to: "/generate",
      },
      {
        label: "Чат с AI",
        icon: "pi pi-fw pi-pencil",
        to: "/chat",
      },
      {
        label: "Контент",
        icon: "pi pi-fw pi-bookmark",
        to: "/contents",
        isAdmin: true,
      },
      {
        label: "Диалог",
        icon: "pi pi-fw pi-book",
        to: "/dialogs",
        isAdmin: true,
      },
    ],
  },
  {
    label: "Администрирование",
    isAdmin: true,
    items: [
      {
        label: "Пользователи",
        icon: "pi pi-fw pi-user",
        to: "/notfound",
        isAdmin: true,
      },
      {
        label: "Контенты пользователей",
        icon: "pi pi-fw pi-bookmark",
        to: "/admin/contents",
        isAdmin: true,
      },
      {
        label: "Диалоги пользователей",
        icon: "pi pi-fw pi-book",
        to: "/admin/dialogs",
        isAdmin: true,
      },
      {
        separator: true,
      },
      {
        label: "Развлечение",
        items: [
          {
            label: 'Игра "Жизнь"',
            icon: "pi pi-fw pi-heart",
            to: "/life",
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: "Documentation",
        icon: "pi pi-fw pi-book",
        to: "/documentation",
        isAdmin: true,
      },
      {
        label: "View Source",
        icon: "pi pi-fw pi-github",
        url: "https://gitflic.ru/project/fourthrider/baltlan-client.git",
        target: "_blank",
        isAdmin: true,
      },
    ],
  },
])

const isLoggedAdmin = ref(false)

const loggedUser = computed(() => store.state.authentication.user)

if (loggedUser) {
  const isAdmin = loggedUser?.value.roles?.some(
    (role) => role === "Администратор"
  )
  if (isAdmin) {
    isLoggedAdmin.value = true
  }
}

const models = ref([])
models.value = allModels.value.filter(
  (model) => !model.isAdmin || model.isAdmin === isLoggedAdmin.value
)
</script>

<style lang="scss" scoped></style>
